// extracted by mini-css-extract-plugin
export default {"risk-change-container":"RiskChange_risk-change-container__aA367"};